import React, { useEffect, useState } from 'react';
import './footer.css';
import { Link } from 'react-router-dom';

function Footer() {

  const [nav, setNav] = useState(false);
  const handleNav = () => setNav(!nav);
  const closeMenu = () => setNav(false);

  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.2, // kicsit előbb figyel
      rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.05}s`; // kicsit lassabb chain effekt
      appearOnScroll.observe(el);
    });
  }, []);
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-row">
          <div className="footer-col large">
            <h5 className="footer-title"></h5>
            <p className='footer-p fade-in'>
             Approaching the understanding and management of human risk and safety in the complex modern landscape. As economic and geopolitical uncertainty has increased together with rapid technological advancement, the risk and threat associated with human behaviour has also increased significantly.
            </p>
          </div>

          <div className="footer-col">
            <h5 className="footer-title"></h5>
            <ul className="footer-links fade-in">
            <li>
            <Link
              to="/"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
              Main
            </Link>
          </li>
            <li>
            <Link
              to="/about"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
              Our Expertise
            </Link>
          </li>
          <li>
            <Link
              to="/clients"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
              How can we help?
            </Link>
          </li>
          <li>
            <Link
              to="/aboutus"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
             About Us
            </Link>
          </li>
          <li>
            <Link
              to="/question"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
             FAQ's
            </Link>
          </li>
          <li>
            <Link
              to="/event"
              onClick={() => {
                closeMenu();
                window.scrollTo({ top: 0, behavior: "smooth" }); // görgetés az oldal tetejére
              }}
            >
             Events
            </Link>
          </li>
            </ul>
          </div>
                <div className="footer-col centered">
        <p>admin@threatadvisorygroup.com</p>
      </div>
        </div>
      </div>

      <div className="footer-bottom ">
        <a href="https://just-ready.com/">2025 - Just-Ready Solutions</a>
      </div>
    </footer>
  );
};

export default Footer;
